import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGasPump, faArrowLeft, faCheckCircle, faCalendarAlt, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';
import Header from '../components/Header';
import TabBar from '../components/TabBar';
import TaxiLoader from '../components/TaxiLoader';
import { isLoggedIn } from '../services/authService';
import { API_ENDPOINTS } from '../services/constants';
import '../styles/YakitHareketlerim.css';

interface YakitHareket {
  Id: number;
  Plate: string;
  Pompa_No: number;
  Urun_Adi: string;
  Satis_Tarihi: string;
  Litre: number;
  Tutar: number;
  Odeme_Tipi: string;
}

interface YakitOzet {
  toplam_litre: number;
  toplam_tutar: number;
  hareket_sayisi: number;
}

const YakitHareketlerim: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [yakitHareketleri, setYakitHareketleri] = useState<YakitHareket[]>([]);
  const [yakitOzet, setYakitOzet] = useState<YakitOzet>({ toplam_litre: 0, toplam_tutar: 0, hareket_sayisi: 0 });
  const [selectedPeriod, setSelectedPeriod] = useState<'gunluk' | 'haftalik' | 'aylik'>('aylik');
  const [userPlaka, setUserPlaka] = useState<string | null>(null);
  const [userGroup, setUserGroup] = useState<string | null>(null);

  useEffect(() => {
    checkAuthAndFetchData();
  }, []);

  const checkAuthAndFetchData = async () => {
    try {
      // Önce userInfo'dan uyeId'yi alalım
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || localStorage.getItem('userInfo') || '{}');
      const uyeId = userInfo.uyeid || localStorage.getItem('uyeid');
      
      console.log('UserInfo:', userInfo);
      console.log('UyeId:', uyeId);
      console.log('isLoggedIn() sonucu:', isLoggedIn());
      
      if (!uyeId) {
        console.warn('UyeId bulunamadı, login sayfasına yönlendiriliyor');
        navigate('/login');
        return;
      }
      
      // isLoggedIn kontrolünü geçici olarak devre dışı bırakalım
      /*
      if (!isLoggedIn()) {
        console.warn('isLoggedIn() false döndü, login sayfasına yönlendiriliyor');
        navigate('/login');
        return;
      }
      */

      // Kullanıcı bilgilerini al
      const response = await fetch(API_ENDPOINTS.WEBSERVICE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ method: 'apibilgileri', uyeid: uyeId })
      });

      // Önce ham yanıtı görelim
      const responseText = await response.text();
      console.log('API Ham Yanıt:', responseText);
      console.log('API Ham Yanıt uzunluğu:', responseText.length);
      
      let data;
      try {
        // Eğer çift JSON varsa, ilkini al
        let jsonText = responseText;
        if (responseText.includes('}{')) {
          jsonText = responseText.split('}{')[0] + '}';
          console.log('Çift JSON tespit edildi, ilki alınıyor:', jsonText);
        }
        
        data = JSON.parse(jsonText);
        console.log('API Parsed Data:', data);
      } catch (parseError) {
        console.error('JSON Parse Hatası:', parseError);
        console.error('Hatalı JSON:', responseText.substring(0, 200) + '...');
        
        // Alternatif: İlk geçerli JSON'u bulmaya çalış
        try {
          const jsonMatch = responseText.match(/\{[^}]*\}/);
          if (jsonMatch) {
            data = JSON.parse(jsonMatch[0]);
            console.log('Alternatif parse başarılı:', data);
          } else {
            throw parseError;
          }
        } catch {
          throw parseError;
        }
      }
      
              // API'den gelen yanıt başarısızsa, sessionStorage'dan kullanıcı bilgilerini al
        if (!data.success) {
          console.warn('API yanıtı başarısız, sessionStorage kullanılıyor:', data.message);
          
          // SessionStorage'dan kullanıcı bilgilerini al
          const kullanici = userInfo;
          setUserGroup(kullanici.grubu || kullanici.GRUBU);
          
          console.log('SessionStorage kullanıcı grubu:', kullanici.grubu || kullanici.GRUBU);
          console.log('SessionStorage kullanıcı bilgileri:', kullanici);
          
          // Debug için geçici olarak devre dışı
          /*
          if ((kullanici.grubu || kullanici.GRUBU) !== 'UYE') {
            console.warn('UYE grubu değil, grup:', kullanici.grubu || kullanici.GRUBU);
            alert(`Bu sayfaya erişim yetkiniz bulunmamaktadır. Mevcut grubunuz: ${kullanici.grubu || kullanici.GRUBU}. Sadece UYE grubu üyeleri yakıt hareketlerini görüntüleyebilir.`);
            navigate('/');
            return;
          }
          */

          // Plaka bilgisi varsa hareketleri getir
          const plakaField = kullanici.plaka || kullanici.PLAKA || kullanici.Plaka;
          if (plakaField) {
            setUserPlaka(plakaField);
            await fetchYakitHareketleri(plakaField, selectedPeriod);
          } else {
            console.warn('Kullanıcının plaka bilgisi bulunamadı');
            setUserPlaka(null);
            setLoading(false);
          }
        } else if (data.success && data.kullanici && data.kullanici.length > 0) {
          const kullanici = data.kullanici[0];
          setUserGroup(kullanici.GRUBU);
          
          console.log('API kullanıcı grubu:', kullanici.GRUBU);
          console.log('API kullanıcı bilgileri:', kullanici);

          const plakaField = kullanici.plaka || kullanici.PLAKA || kullanici.Plaka;
          if (plakaField) {
            setUserPlaka(plakaField);
            await fetchYakitHareketleri(plakaField, selectedPeriod);
          } else {
            console.warn('API kullanıcı bilgilerinde plaka bulunamadı');
            setUserPlaka(null);
            setLoading(false);
          }
        } else {
          console.error('Kullanıcı bilgileri alınamadı ve sessionStorage de uygun değil');
          navigate('/login');
        }
    } catch (error) {
      console.error('Kullanıcı bilgileri alınamadı:', error);
      navigate('/login');
    }
  };

  const fetchYakitHareketleri = async (plaka: string, period: 'gunluk' | 'haftalik' | 'aylik') => {
    try {
      setLoading(true);
      console.log('Yakıt hareketleri API çağrısı:', { plaka, period });
      
      const response = await fetch(API_ENDPOINTS.WEBSERVICE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ method: 'getYakitHareketleri', plaka, period })
      });

      const responseData = await response.json();
      console.log('Yakıt hareketleri API yanıtı:', responseData);

      if (responseData.success && responseData.data) {
        // API'den gelen veri yapısı: { success: true, data: { hareketler: [...], ozet: {...} } }
        const { hareketler = [], ozet = { toplam_litre: 0, toplam_tutar: 0, hareket_sayisi: 0 } } = responseData.data;
        
        console.log('İşlenen hareketler:', hareketler);
        console.log('İşlenen özet:', ozet);
        
        setYakitHareketleri(hareketler);
        setYakitOzet(ozet);
      } else {
        console.error('Yakıt hareketleri başarısız:', responseData.message);
        setYakitHareketleri([]);
        setYakitOzet({ toplam_litre: 0, toplam_tutar: 0, hareket_sayisi: 0 });
      }
    } catch (error) {
      console.error('Yakıt hareketleri hatası:', error);
      setYakitHareketleri([]);
      setYakitOzet({ toplam_litre: 0, toplam_tutar: 0, hareket_sayisi: 0 });
    } finally {
      setLoading(false);
    }
  };

  const handlePeriodChange = async (newPeriod: 'gunluk' | 'haftalik' | 'aylik') => {
    setSelectedPeriod(newPeriod);
    if (userPlaka) {
      await fetchYakitHareketleri(userPlaka, newPeriod);
    }
  };

  const formatPeriodText = (period: string): string => {
    switch(period) {
      case 'gunluk': return 'Günlük';
      case 'haftalik': return 'Haftalık';
      case 'aylik': return 'Aylık';
      default: return 'Aylık';
    }
  };

  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2
    }).format(amount);
  };

  if (loading) {
    return <TaxiLoader message="Yakıt hareketleri yükleniyor..." />;
  }

  return (
    <div className="yakit-hareketlerim-container">
      <Header title="Yakıt Hareketlerim" />
      
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <div className="hero-icon">
            <FontAwesomeIcon icon={faGasPump} />
          </div>
          <h1 className="hero-title">Yakıt Hareketlerim</h1>
          <p className="hero-subtitle">
            {userPlaka ? `${userPlaka} - ${formatPeriodText(selectedPeriod)} Hareketler` : 'Plaka bilgisi bulunamadı'}
          </p>
        </div>
      </div>

      <div className="page-content">
        {userPlaka ? (
          <>
            {/* Period Seçim Butonları */}
            <div className="period-selector">
              <button 
                className={`period-btn ${selectedPeriod === 'gunluk' ? 'active' : ''}`}
                onClick={() => handlePeriodChange('gunluk')}
              >
                <FontAwesomeIcon icon={faCalendarAlt} />
                Günlük
              </button>
              <button 
                className={`period-btn ${selectedPeriod === 'haftalik' ? 'active' : ''}`}
                onClick={() => handlePeriodChange('haftalik')}
              >
                <FontAwesomeIcon icon={faCalendarAlt} />
                Haftalık
              </button>
              <button 
                className={`period-btn ${selectedPeriod === 'aylik' ? 'active' : ''}`}
                onClick={() => handlePeriodChange('aylik')}
              >
                <FontAwesomeIcon icon={faCalendarAlt} />
                Aylık
              </button>
            </div>

            {/* İstatistik Kartları */}
            <div className="stats-section">
              <div className="stats-grid">
                <div className="stat-card litre">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faGasPump} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-number">{yakitOzet.toplam_litre.toFixed(1)}</div>
                    <div className="stat-label">Toplam Litre</div>
                  </div>
                </div>
                <div className="stat-card tutar">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faMoneyBillWave} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-number">{yakitOzet.toplam_tutar.toFixed(2)}</div>
                    <div className="stat-label">Toplam Tutar (₺)</div>
                  </div>
                </div>
                <div className="stat-card hareket">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-number">{yakitOzet.hareket_sayisi}</div>
                    <div className="stat-label">İşlem Sayısı</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Yakıt Hareketleri Listesi */}
            <div className="hareket-section">
              <div className="section-header">
                <h3>Hareket Detayları</h3>
                <div className="section-badge">
                  {yakitHareketleri.length} kayıt
                </div>
              </div>
              
              {yakitHareketleri.length > 0 ? (
                <div className="hareket-list">
                  {yakitHareketleri.map((hareket, index) => (
                    <div key={index} className="hareket-card">
                      <div className="hareket-header">
                        <div className="hareket-urun">
                          <div className="urun-badge">
                            <FontAwesomeIcon icon={faGasPump} />
                            <span>{hareket.Urun_Adi}</span>
                          </div>
                        </div>
                        <div className="hareket-tarih">
                          <div className="tarih">{new Date(hareket.Satis_Tarihi).toLocaleDateString('tr-TR')}</div>
                          <div className="saat">{new Date(hareket.Satis_Tarihi).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}</div>
                        </div>
                      </div>
                      <div className="hareket-body">
                        <div className="hareket-info">
                          <div className="info-item">
                            <span className="info-label">Pompa:</span>
                            <span className="info-value pompa">Pompa {hareket.Pompa_No}</span>
                          </div>
                          <div className="info-item">
                            <span className="info-label">Litre:</span>
                            <span className="info-value litre">{hareket.Litre.toFixed(2)} L</span>
                          </div>
                          <div className="info-item">
                            <span className="info-label">Tutar:</span>
                            <span className="info-value tutar">{hareket.Tutar.toFixed(2)} ₺</span>
                          </div>
                          <div className="info-item">
                            <span className="info-label">Ödeme:</span>
                            <span className="info-value">{hareket.Odeme_Tipi}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-state">
                  <div className="empty-icon">
                    <FontAwesomeIcon icon={faGasPump} />
                  </div>
                  <h4>Hareket Kaydı Bulunamadı</h4>
                  <p>Bu dönem için {userPlaka} plakasına ait yakıt hareketi bulunmamaktadır.</p>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">
              <FontAwesomeIcon icon={faGasPump} />
            </div>
            <h4>Plaka Bilgisi Bulunamadı</h4>
            <p>Yakıt hareketlerini görüntülemek için plaka bilginiz sistemde kayıtlı olmalıdır. Lütfen sistem yöneticinizle görüşünüz.</p>
          </div>
        )}
      </div>

      <TabBar />
    </div>
  );
};

export default YakitHareketlerim; 